import ColorCF from './ColorCF';

export default ColorCF;
